import { useMemo } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useHistory } from 'react-router-dom';
import type { History, LocationDescriptor } from 'history';

import { useConfig } from '../../../../context';
import { mapRoutePath } from './mapRoutePath';

export function useHistoryWrapper(): History {
	const history = useHistory();
	const enabled = useConfig().global.alternativeRouting ?? false;

	return useMemo(() => {
		if (!enabled) {
			return history;
		}

		const wrap = (to: LocationDescriptor): LocationDescriptor => {
			if (typeof to === 'string') {
				return mapRoutePath(to, true);
			}

			if (to && typeof to === 'object' && typeof to.pathname === 'string') {
				return { ...to, pathname: mapRoutePath(to.pathname, true) };
			}

			return to;
		};

		return new Proxy(history, {
			get(target, prop, receiver) {
				if (prop === 'push' || prop === 'replace') {
					return (to: LocationDescriptor, state?: unknown) =>
						(target[prop] as (descriptor: LocationDescriptor, state?: unknown) => void)(wrap(to), state);
				}

				return Reflect.get(target, prop, receiver);
			}
		});
	}, [history, enabled]);
}
